import React from 'react';
import IntroSection from '../components/IntroSection';
import MFSolutions from '../components/MFSolutions';
import BlueSectionDivider from '../components/BlueSectionDivider';
import CountriesSection from '../components/CountriesSection';
import TechStackSection from '../components/TechStackSection';
import MFFaq from '../components/MFFaq';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import MFBenefits from '../components/MFBenefits';

const Manufacturing=()=>{
    return(
        <div>
            <IntroSection title="Manufacturing Software Solutions" paragraph="Empower your manufacturing operations with next-level control and visibility." backgroundImage="/images/manufacturing-bg.webp"/>
           
            <MFSolutions/>
            <BlueSectionDivider/>
            <MFBenefits imageSrc="https://cdn.prod.website-files.com/63d3b504212f2224c6e39423/65830ca3bdbcd77576dee450_Technical%20consultancy%20fintech.png"/>
            <BlueSectionDivider/>
            <CountriesSection/>
            <BlueSectionDivider/>
            <TechStackSection/>
            <MFFaq/>
            <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>

        </div>
    )
}
export default Manufacturing;